// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3dhWP","content":"ManualTimeModal_content__1kaW-"};